import { LoadableAfterPaint } from '@confluence/loadable';

export const Onboarding = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsOnboarding" */ './components/Onboarding/index.ts'
			)
		).Onboarding,
});
